module.exports = [
  {
    "url": "/prototype/dialogue-1.wav",
    "durationMs": 63321,
    "source": "本地语音合成，虚构演示台词",
    "segments": [
      {
        "speaker": "说话人A",
        "startMs": 0,
        "endMs": 9943,
        "text": "今天我们一起讨论一道数学题。请先想一想，题目里给出了哪些已知条件，你准备怎样开始分析？"
      },
      {
        "speaker": "说话人B",
        "startMs": 10293,
        "endMs": 20549,
        "text": "我觉得应该先把数量关系画出来，再看看哪些条件可以直接使用。我还没有确定最后一步应该怎么计算。"
      },
      {
        "speaker": "说话人A",
        "startMs": 20899,
        "endMs": 31087,
        "text": "你的想法很好。请把图画在纸上，标出已经知道的量。我们先检查第一步，不需要着急得出最后的答案。"
      },
      {
        "speaker": "说话人B",
        "startMs": 31437,
        "endMs": 40949,
        "text": "我画出来以后发现，两部分数量之间有一个固定的关系。我可以先计算其中一部分，再计算总数。"
      },
      {
        "speaker": "说话人A",
        "startMs": 41299,
        "endMs": 51379,
        "text": "现在请你向同学解释这个方法为什么成立。遇到不确定的地方可以停下来，我们一起寻找可以验证的依据。"
      },
      {
        "speaker": "说话人B",
        "startMs": 51729,
        "endMs": 62971,
        "text": "课后请整理今天的解题步骤，记录一个容易出错的地方。下一次课堂，我们用相似问题检验这个方法是否真正掌握。"
      }
    ]
  },
  {
    "url": "/prototype/dialogue-2.wav",
    "durationMs": 65722,
    "source": "本地语音合成，虚构演示台词",
    "segments": [
      {
        "speaker": "说话人A",
        "startMs": 0,
        "endMs": 10432,
        "text": "您好，今天和您交流一下孩子最近的学习情况。这是一段虚构的演示沟通，不涉及任何真实学生的信息。"
      },
      {
        "speaker": "说话人B",
        "startMs": 10782,
        "endMs": 20008,
        "text": "孩子在课堂上能够主动提问，但在独立完成综合题时，还需要练习把问题分成几个小步骤。"
      },
      {
        "speaker": "说话人A",
        "startMs": 20358,
        "endMs": 30614,
        "text": "我们希望了解家庭练习应该怎样安排。每天的时间比较有限，希望能够有明确的重点和可以检查的目标。"
      },
      {
        "speaker": "说话人B",
        "startMs": 30964,
        "endMs": 42057,
        "text": "建议每天选择一道代表性的题目，先口头说明思路，再独立完成。请记录卡住的步骤，不要只核对最后的答案。"
      },
      {
        "speaker": "说话人A",
        "startMs": 42407,
        "endMs": 54032,
        "text": "我会在本周五前整理一份学习建议，并请学管老师与您确认下一次沟通的时间。这项安排需要记录下来并持续跟进。"
      },
      {
        "speaker": "说话人B",
        "startMs": 54382,
        "endMs": 65372,
        "text": "好的，我们按照这个计划先练习一周，再一起看看哪些方法有效。反馈内容会由老师核实和审核后提供给您。"
      }
    ]
  },
  {
    "url": "/prototype/dialogue-3.wav",
    "durationMs": 68175,
    "source": "本地语音合成，虚构演示台词",
    "segments": [
      {
        "speaker": "说话人A",
        "startMs": 0,
        "endMs": 11093,
        "text": "今天的教研复盘围绕课堂提问展开。我们先回看一段示例，重点观察学生是否有足够时间表达自己的思考过程。"
      },
      {
        "speaker": "说话人B",
        "startMs": 11443,
        "endMs": 22581,
        "text": "我注意到自己在学生停顿的时候，比较快地给出了答案。这样虽然推进了课堂，但没有完全了解学生困难在哪里。"
      },
      {
        "speaker": "说话人A",
        "startMs": 22931,
        "endMs": 33534,
        "text": "下一次可以先等待几秒，再提出一个更小的问题。请学生说出已经确定的条件，而不是直接告诉他下一步。"
      },
      {
        "speaker": "说话人B",
        "startMs": 33884,
        "endMs": 43385,
        "text": "我准备在下一节课实践这个方法，记录两次提问后的学生回应，并选择一个片段作为复盘依据。"
      },
      {
        "speaker": "说话人A",
        "startMs": 43735,
        "endMs": 55953,
        "text": "我们把它整理为一个改进计划，明确实践时间、记录方式和反馈目标。案例经过核实和教研审核后，才进入共享方法库。"
      },
      {
        "speaker": "说话人B",
        "startMs": 56303,
        "endMs": 67825,
        "text": "阶段复盘时，需要比较相近场景中的实际表现。样本不足时只记录观察和建议，不根据一次课堂给教师作排名。"
      }
    ]
  }
]
